import React from 'react';
import dynamic from 'next/dynamic';
import { ICategoryProps } from './interfaces';
import SearchResultTitle from '@components/Shared/SearchResult/SearchResultTitle';
import SearchResultWrapper from '@components/Shared/SearchResult/SearchResultWrapper';

const DynamicSearchResultGrid = dynamic(
  () => import('@components/Shared/SearchResult/SearchResultGrid')
);

const Category: React.FC<ICategoryProps> = ({ posts, name }) => {
  return (
    <SearchResultWrapper>
      <SearchResultTitle title="Category:" value={name} />
      <DynamicSearchResultGrid posts={posts} />
    </SearchResultWrapper>
  );
};

export default Category;
